import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/tiptap/styles.css';

import App from './App';
import './style/main.scss';
import '@util/axiosDefaults';
import { initSentry, setSentryUserFromStore, Sentry } from '@util/sentry';

initSentry();

function ReactApp() {
  const queryClient = new QueryClient();

  useEffect(() => {
    setSentryUserFromStore();
  }, []);

  return (
    <Sentry.ErrorBoundary
      fallback={<div>Something went wrong. Please refresh and try again.</div>}
      showDialog={false}
    >
      <QueryClientProvider client={queryClient}>
        <MantineProvider
          theme={{
            fontFamily: 'DM Sans',
            fontFamilyMonospace: 'DM Sans, monospace',
            headings: { fontFamily: 'DM Sans, sans-serif' },
            components: {
              Card: {
                defaultProps: {
                  radius: 'md',
                  p: 'sm',
                  withBorder: true,
                  style: {
                    overflow: 'visible',
                  },
                },
              },
            },
          }}
        >
          <App />
        </MantineProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}

createRoot(document.getElementById('app')).render(<ReactApp />);
